/**
* @description
* # name controller --> transitionOneController
* # As Controller --> transitionOne
* brief comment controller shows the view for the main page of assignTimeRange
*/

export default class transitionOneController {
	constructor($scope,ngNotify,UserInfoConstant,$state,$filter,studentsServices,ambitsServices, coresServices, $modal, evaluationsServices) {
		this.$scope = $scope;
		this.ngNotify = ngNotify;
		this.$modal = $modal
		this.studentsServices = studentsServices.services
		this.ambitsServices = ambitsServices.services
		this.coresServices = coresServices.services
		this.servicesPeriod = evaluationsServices.servicesPeriod
		this.$state = $state
		this.buttonActions = true
		this.$scope.grid = false;
		this.$scope.edit = true;
		this.$scope.titleList = true;
		this.$translate = $filter('translate')
		this.conceptId = 0
		this.levelId = 5
		this.expandPanels = false
		this.$scope.periodSelect = null
		this.detailsStudents ={
			enableFiltering: true
		}
		this.detailsIndicators = {
			enableFiltering: true
		}

		this.tabs = [
			{ label: 'LISTA DE CURSO', content: 'Contenido para Lista de Curso', id_code: 1  },
			{ label: 'EVALUACIÓN', content: 'Contenido para Evaluación', id_code: 2 },
			{ label: 'ESTADÍSTICAS', content: 'Contenido para Estadísticas', id_code: 3 },
			{ label: 'INFORMES', content: 'Contenido para Informes' }
		  ];
		
		this.tableInitializeMethod()
		this.$scope.UserInfoConstant = UserInfoConstant;
		this.$scope.$watch('UserInfoConstant[0].details[0]', (details) => {
			if (details !== undefined) {
				this.user = details.user.id;
				this.user_id = details.user.id;
				this.conceptId = details.user.conceptId
				if (details.user.levels.length){
					details.user.levels.map((level) => {
						if (level.ds_name === 'Transición 1'){
							this.levelId = level.id_code
						}
					})
				}
				this.init()
			}
		});

	}

	init(){
		this.params = {
			level_id: this.levelId,
			concept_id: this.conceptId
		}

		this.detailsIndicators.columnDefs = [
			{field: 'id_code',            displayName: 'Id', },
			{field: 'ds_name',            displayName: 'Nombre', },
		]
		
		this.getPeriod()
	}

	getPeriod(){
		this.servicesPeriod.getPeriod().$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
				this.params.period_id = 3
				this.getStudents()
				this.getAmbits()
			}else{
				this.periodList = dataReturn.results
				this.periodList.map((period) => {
					if(period.is_current ){
						this.$scope.periodSelect = period.id_code
					}
				})

				this.params.period_id = this.$scope.periodSelect
				this.getStudents()
				this.getAmbits()
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	tableInitializeMethod() {
		this.detailsStudents.columnDefs = [
			{field: 'ds_name',            displayName: 'Nombres', },
			{field: 'ds_last_name',            displayName: 'Apellidos', },
			{field: 'ds_rut',   displayName: 'Rut', },
			{field: 'ds_mail',   displayName: 'Email Apode.', },
			{field: 'ds_name_attorney',   displayName: 'Nombre Apode.', },
			{field: 'ds_gender',   displayName: 'Género', },
			{field: 'nationality',   displayName: 'Nacionalidad', },
			{field: 'admission_date',   displayName: 'Fecha Ingreso', },
		]
	}

	getStudents() {
		this.studentsServices.getEnabledEvaluations(this.params).$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.detailsStudents.data = this.setAllDataStudents(dataReturn.results)
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	getAmbits(){
		this.ambitsServices.getAmbits(this.params).$promise.then((dataReturn) => {
			if(dataReturn.results.lenght == 0){
				this.ngNotify.set('no existen registros','warn')
			}else{
				this.ambits = []
				this.ambitsList = dataReturn.results
				this.ambitsList.map((item) => {
					const coreFormat = []
					item.cores.forEach(core => {
						const response = []
						core.learning_objectives.forEach(learning => {
							learning.indicators.map(indicator => {
								response.push({
									id_code: indicator.id_code,
									ds_name: indicator.ds_name,
									id_learning: learning.id_code,
									ds_learning: learning.ds_name
								})
							})
						})
						coreFormat.push({
							id_code: core.id_code,
							ds_name: core.ds_name,
							order: (core.id_code === 8 || core.id_code === 19) ? 2 : ((core.id_code === 9 || core.id_code === 20) ? 1 : ((core.id_code === 7 || core.id_code === 18) ? 3 : core.id_code)),
							learning_objectives: response
						})
					})
					this.ambits.push(
						{
							id_code: item.id_code,
							ds_name: item.ds_name,
							order: (item.id_code === 1 || item.id_code === 8) ? 2 : ((item.id_code === 4 || item.id_code === 9) ? 1 : (item.id_code === 5 || (item.id_code === 10) ? 3 : 4)),
							cores: coreFormat,
							columnDefs: [
								{field: 'id_code',            displayName: 'Id', },
								{field: 'ds_name',            displayName: 'Nombre', },
							]
					})
						
				})
			}
		}, (err) => {
			this.ngNotify.set('No se ha podido conectar con el servicio','error');
		})
	}

	selectChanged(periodSelect){
		this.$scope.periodSelect = periodSelect
		this.params.period_id = periodSelect

		this.getStudents()
		this.getAmbits()
	}

	setAllDataStudents(students) {
		return students.map(student => {
			return {
				studentId: student.id_code,
				ds_name: student.ds_name,
				ds_last_name: student.ds_last_name,
				ds_rut: student.ds_rut,
				ds_mail: student.ds_mail,
				ds_name_attorney: student.ds_name_attorney,
				ds_gender: student.gender.ds_name,
				nationality: student.nationality,
				admission_date: student.admission_date,
				first_eval: null,
				second_eval: null
				
			}
		})
	}

	edit(){
		this.$scope.editSave = true;
		this.$scope.edit = false;
		this.$scope.titleList = false;
		this.$scope.titleEdit = true;
		this.$scope.isDisabled = false;
	}

	cancelEdit(){
		this.$scope.editSave = false;
		this.$scope.edit = true;
		this.$scope.titleList = true;
		this.$scope.titleEdit = false;
		this.getDetailsFunction({ambit_id : this.ambitId});
		
	}

	saveEdit(){
		const params = {
			ambit_id: this.ambitId,
			name: this.ambitName,
			user_id: this.user_id
		}

		this.services.updateAmbits(params).$promise.then((dataReturn) => {
			if(dataReturn.status == 0){
				this.ngNotify.set('Se ha modificado de manera correcta el Ambito','success');
				this.$state.go(this.$state.current, {}, {reload: true});
				this.$scope.edit = true;
				this.$scope.editSave = false;
				this.$scope.titleList = true;
				this.$scope.titleEdit = false;

			}else{
				if (dataReturn.isUniqueViolation) {
					this.ngNotify.set('Nombre de ambito se repite','error');
				}
				this.$scope.isDisabled = false;
			}
		}, (err) => {
			if (err.data.isUniqueViolation) {
				this.ngNotify.set('Nombre de ambito ya existe','error');
			} else {
				this.ngNotify.set('No se ha podido conectar con el servicio','error');
			}
			this.$scope.isDisabled = false;
		})

	}

	editIndicatorStudents(learning) {
		const data = { data: this.detailsStudents.data, indicatorId: learning.id_code, indicatorName: learning.ds_name, perioId: this.$scope.periodSelect, levelId: this.levelId }
		const modalInstance  = this.$modal.open({
			template: require('../../modal-evaluation-students/modalEvaluation.html'),
			animation: true,
			scope: this.$scope,
			controller: 'modalEvaluationController',
			controllerAs: 'modalEvaluation',
			size: '',
			windowClass: 'modal-extra-large',
			resolve: {
				// Pasa la variable al controlador modal
				variableAEnviar: function () {
					return data
				}
			}
		})
	}

	goToModalStudents(id) {
		const data = { level : 5, type_bi : id}
		const modalInstance  = this.$modal.open({
			template: require('../../modal-power-bi/modalPowerBi.html'),
			animation: true,
			scope: this.$scope,
			controller: 'modalPowerBiController',
			controllerAs: 'modalPowerBi',
			size: 'lg',
			// windowClass: 'modal-large',
			resolve: {
				// Pasa la variable al controlador modal
				variableAEnviar: function () {
					return data
				}
			}
		})
	}

	toggleList(isHide) {
		this.$scope.toggle = isHide
	}
}
transitionOneController.$inject=['$scope','ngNotify','UserInfoConstant','$state','$filter', 'studentsServices', 'ambitsServices', 'coresServices', '$modal', 'evaluationsServices']


// WEBPACK FOOTER //
// ./src/app/course-front/transition-one/view/transitionOneController.js